import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';

import PhotoSwipe from 'photoswipe';
window.PhotoSwipe = PhotoSwipe;

import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
window.PhotoSwipeUI_Default = PhotoSwipeUI_Default;


const Registry = new Map();
let idsIterator = 0;

export class Gallery
{
	options = {
		// showAnimationDuration: 0,
		// hideAnimationDuration: 0
	};

	template = `
		<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="pswp__bg"></div>

			<div class="pswp__scroll-wrap">

				<div class="pswp__container">
					<div class="pswp__item"></div>
					<div class="pswp__item"></div>
					<div class="pswp__item"></div>
				</div>

				<div class="pswp__ui pswp__ui--hidden">

					<div class="pswp__top-bar">

						<div class="pswp__counter"></div>

						<button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

						<button class="pswp__button pswp__button--share" title="Share"></button>

						<button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

						<button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

						<div class="pswp__preloader">
							<div class="pswp__preloader__icn">
							<div class="pswp__preloader__cut">
								<div class="pswp__preloader__donut"></div>
							</div>
							</div>
						</div>
					</div>

					<div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
						<div class="pswp__share-tooltip"></div>
					</div>

					<button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
					</button>

					<button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
					</button>

					<div class="pswp__caption">
						<div class="pswp__caption__center"></div>
					</div>

				</div>

			</div>

		</div>
	`;


	#modal = undefined;
	#slides = [];

	#id = false;

	constructor(options = {})
	{

		this.#id = 'gallery_' + (++idsIterator);
		this.options = {
			...this.options,
			...(options || {})
		};

		this.create();
	}


	get slides()
	{
		return this.#slides;
	}

	set slides(val)
	{
		if (this.#slides === val)
			return;

		this.#slides = val.map(item => {
			return {
				h: item.HEIGHT,
				src: item.SRC,
				w: item.WIDTH,
			}
		})
	}

	create()
	{
		const container = document.createElement('div');
		container.innerHTML = this.template;

		this.#modal = container.children[0];
		document.body.appendChild(this.#modal);
	}

	open()
	{
		const instance = new PhotoSwipe(this.#modal, PhotoSwipeUI_Default, this.#slides, this.options);
		instance.init();
		instance.listen('close', () => {
			this.dispose()
		});

		return instance;
	}

	dispose ()
	{
		this.#modal.remove()
		this.#modal = undefined
	}
};
